import { clsx } from 'clsx';
import { Switch as SwitchPrimitive } from 'radix-ui';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export type SwitchProps = ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>;

/** On/off toggle on Radix (`role="switch"`). Pair with a visible label (`<SwitchField>` or `<Label htmlFor>`). */
export function Switch({ className, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root className={clsx('switch', className)} {...props}>
      <SwitchPrimitive.Thumb className="switch__thumb" />
    </SwitchPrimitive.Root>
  );
}

export interface SwitchFieldProps extends Omit<SwitchProps, 'children'> {
  label: ReactNode;
}

/** A switch with its label on one row. */
export function SwitchField({ label, className, disabled, ...props }: SwitchFieldProps) {
  return (
    <label className={clsx('switch-field', className)} data-disabled={disabled || undefined}>
      <span className="switch-field__label">{label}</span>
      <Switch disabled={disabled} {...props} />
    </label>
  );
}
